(function () {
  'use strict';

  class MultiVideoService {
    constructor($rootScope, Restangular) {
      this.restangular = Restangular;
      this.sharedScope = $rootScope.$new();
    }

    updateVideo(video) {
      this.sharedScope.$emit('update-video', video);
    }

    getAlertaById(alertaId) {
      return this.restangular.one('/alerta/alertas/ids').get({ids: alertaId})
        .then(response => response.plain())
        .catch(error => {
          console.error('Erro ao buscar alerta pelo ID:', error);
          return null;
        });
    }

    getVeiculoById(veiculoId) {
      return this.restangular.one('/veiculo/v2/veiculos').get({
        veiculoId: veiculoId,
        fields: 'placa,prefixo'
      })
        .then(response => {
          const data = response.plain();
          return data && data.content && data.content.length > 0 ? data.content[0] : null;
        })
        .catch(error => {
          console.error('Erro ao buscar veículo:', error);
          return null;
        });
    }
  }

  MultiVideoService.$inject = ['$rootScope', 'Restangular'];

  angular
    .module('videoPlayer')
    .service('MultiVideoService', MultiVideoService);
}());
